import React from 'react';

import APModal from 'components/Modal/APModal';

export const EmailSentConfirmation = ({
  dismiss,
}) => {
  return (
    <APModal
      open
      onClose={dismiss}
      name="email-sent-confirmation"
      title="Your email has been sent."
      actions={(
        <button
          className="button"
          onClick={dismiss}
        >
          Got it
        </button>
      )}
    />
  );
};
